import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import { Routes, Route, HashRouter } from 'react-router-dom';
import Hipermapa from '../pages/index';
import HttpsRedirect from 'react-https-redirect';
import { getMapProperties, getParametrizacion, getVisorId, getVisorNameFromUrl } from './Utils/VisorsUtils';

const isVisorReady = (visor, id) => {
  if (id === 'No') {
    return true;
  }
  return visor && Object.keys(visor).length > 0;
};

export default function App() {
  const [visor, setVisor] = useState(undefined);
  const [id, setId] = useState(undefined);
  const [map, setMap] = useState(false);
  const [key, setKey] = useState(Date.now().toString());

  const idRef = useRef(id);

  idRef.current = id;

  const url = window.location.href;
  if (url.indexOf('#') !== -1) {
    let newUrl = url.replace(/#/g, '?');
    window.location.replace(newUrl);
  }

  const loadMap = async (xml) => {
    const newVisor = await getMapProperties(xml);
    newVisor.idCat = visor.idCat;
    setVisor(newVisor);
    setMap(true);
    // setId('No');
    // Generamos nueva key para refrescar el componente
    const newKey = Date.now().toString();
    setKey(newKey);
  };

  useEffect(() => {
    const fetchData = async () => {
      let visorId;
      let visorName = getVisorNameFromUrl(url);
      const urlParams = new URLSearchParams(window.location.search);
      const urlId = urlParams.get('ID');
      // const login = window.location.search.includes('/login/');

      if (urlId) {
        visorId = urlId;
      } else if (visorName) {
        visorId = await getVisorId(visorName);
      } else {
        setId('No');
        return;
      }

      if (visorId) {
        let { idCat, capaFons, transparenciaFons, layers, bbox, redLining, favs, mapName } = await getParametrizacion(visorId);
        setVisor({
          capaFons: capaFons,
          layers: layers,
          transparenciaFons: transparenciaFons,
          bbox: bbox,
          idCat: idCat,
          redLining: redLining,
          favs: favs,
          mapName: mapName
          // login: login
        });
        if (idRef.current !== visorId) {
          setId(visorId);
        }
      } else {
        setId('No');
      }
    };
    fetchData();
  }, [url]);

  return (
    <HttpsRedirect>
      <HashRouter>
        <Routes>
          {isVisorReady(visor, id) && <Route path="/" element={<Hipermapa key={key} id={id} visor={visor} loadMap={loadMap} map={map} />} exact />}
        </Routes>
      </HashRouter>
    </HttpsRedirect>
  );
}
